import React, { Suspense, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { LoadingIndicator, Message } from '../../components';
import { useObservable } from '../../hooks';
import { authService } from '../../services';

const loadAuthenticatedApp$ = (): Promise<typeof import('../authenticated/authenticated.app')> =>
  import('../authenticated/authenticated.app');
const AuthenticatedApp = React.lazy(loadAuthenticatedApp$);
const UnauthenticatedApp = React.lazy(() => import('../unauthenticated/unauthenticated.app'));

/** The App Shell */
const App = (): React.ReactElement => {
  const { value: user, error, isLoading } = useObservable(authService.user$);

  // Pre-loading
  useEffect(() => {
    loadAuthenticatedApp$();
  }, []);

  if (!authService.isInitialized() || isLoading) {
    return <LoadingIndicator>Application is starting up ...</LoadingIndicator>;
  }

  return (
    <>
      {error ? (
        <Message type="error">An authentication error occurred. Please reload the page.</Message>
      ) : null}
      <Suspense fallback={<LoadingIndicator>Loading the UI ...</LoadingIndicator>}>
        <Router>
          {user?.isVerified ? <AuthenticatedApp user={user} /> : <UnauthenticatedApp user={user} />}
        </Router>
      </Suspense>
    </>
  );
};

export default App;
